// eslint-disable-line no-unused-vars
// eslint-disable-next-line no-unused-vars
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import timezone from 'dayjs/plugin/timezone';
import weekday from 'dayjs/plugin/weekday';

dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(timezone);
dayjs.tz.setDefault('Europe/Berlin');
import('dayjs/locale/de');

export function genetic(val) {
  switch (val) {
    case 'sativa':
      return 'Sativa';
    case 'indica':
      return 'Indica';
    case 'hybrid':
      return 'Hybrid';
    default:
      return 'n.a.';
  }
}
export function manufacturingprocess(val) {
  switch (val) {
    case 'ethanol':
      return 'Ethanol Extraktion';
    case 'CO2':
      return 'CO2-Extraktion';
    case 'soxhlet':
      return 'Soxhlet';
    case 'ethanol_tween':
      return 'Ethanol-/Tweenextraktion';
    default:
      return 'n.a.';
  }
}

export function radiationstate(state) {
  switch (state) {
    case true:
      return 'bestrahlt';
    case 'true':
      return 'bestrahlt';
    case false:
      return 'unbestraht';
    case 'false':
      return 'unbestraht';
    default:
      return 'n.a.';
  }
}

export function availabilityIcon(state) {
  switch (state) {
    case true:
      return 'check_circle';
    case 1:
      return 'check_circle';
    case 'true':
      return 'check_circle';
    case false:
      return 'cancel';
    case 'false':
      return 'cancel';
    case 0:
      return 'cancel';
    default:
      return 'cancel';
  }
}

export function normalizeSortKey(obj) {
  return [`${obj.order != 'DESC' ? '' : '-'}${obj.key}`];
}
/**
 * The function normalizes an object by adding null values for missing keys based on a provided list of
 * mapped fields.
 * @param item - The object that needs to be normalized, with keys and values that may or may not match
 * the desired format.
 * @param mappedFields - mappedFields is an array of strings that represents the fields that should be
 * present in the item object. If any of these fields are missing from the item object, they will be
 * added with a value of null. If there are any fields in the item object that are not in the
 * mappedFields array,
 */

export function normalizeItem(item, mappedFields) {
  const itemKeys = Object.keys(item);
  let differenceKeys = mappedFields
    .filter((x) => !itemKeys.includes(x))
    .concat(itemKeys.filter((x) => !mappedFields.includes(x)));
  const differenceKeysLength = differenceKeys.length - 1;
  for (let i = 0; i <= differenceKeysLength; i++) {
    item[differenceKeys[i]] = null;
  }
}

export function sortingBtnClass(key, order, targetKey) {
  return [
    //key == targetKey && order == "ASC" ? "mirror-y" : "",
    key == targetKey ? 'text-primary' : ''
  ];
}

export function deliveryType(deliveryType) {
  if (deliveryType == null || typeof deliveryType === 'undefined') return '';
  const deliveryTypeOptions = {
    pickup: 'Abholer',
    internal_shipping: 'Botendienst',
    dhl_express: 'DHL Express',
    dhl: 'DHL',
    go_express: 'GO! Express',
    urbify: 'Urbify',
    urbify_next_day: 'Urbify Next Day',
    'uber_eats': 'Uber Eats',
    'n.a.': 'n.a.'
  };
  return deliveryTypeOptions[deliveryType] != null && deliveryTypeOptions[deliveryType] != 'undefined'
    ? deliveryTypeOptions[deliveryType]
    : '';
}

export function commentType(commentType) {
  switch (commentType) {
    case 'common':
      return 'Allgemein';
    case 'payment':
      return 'Zahlung';
    default:
      return null;
  }
}

export function paymentType(paymentType) {
  switch (paymentType) {
    case 'prepayment':
      return 'Vorkasse';
    case 'fastbill':
      return 'Fastbill';
    case 'miscellaneous':
      return 'Sonstige';
    default:
      return 'Sonstige';
  }
}

export function paymentStatus(status) {
  switch (status) {
    case 'draft':
      return 'Entwurf';
    case 'open':
      return 'Rechnung versendet';
    case 'partially_paid':
      return 'zum Teil bezahlt';
    case 'paid':
      return 'bezahlt';
    case 'under_review':
      return 'Zahlungsprüfung';
    default:
      return '';
  }
}

export function orderDeliveryPeriod(deliveryPeriod) {
  switch (deliveryPeriod) {
    case 'morning':
      return 'Vormittag 8-12';
    case 'end_of_day':
      return 'End of day 8-18';
    default:
      return '';
  }
}

export function orderColorCode(status, date) {
  const statusColorCode = orderStatusColorCode(status);
  const dateCreatedColorCode = orderDateCreatedColorCode(date);
  const colorCode =
    statusColorCode != null || typeof statusColorCode != 'undefined' ? statusColorCode : dateCreatedColorCode;
  return colorCode;
}

export function orderHandoverDeliveryDateColorCode(deliveryType, handoverDeliveryDate, preferredDateOfDelivery) {
  if (['internal_shipping', 'dhl_express', 'go_express'].includes(deliveryType)) {
    if (preferredDateOfDelivery === null) return 'var(--q-negative)';
    if (handoverDeliveryDate === true) return 'var(--q-primary)';
    if (handoverDeliveryDate === false) return 'var(--q-warning)';
  }
  return 'unset';
}

export function orderDeliveryTypeColorCode(deliveryType, noPrescription) {
  if (['internal_shipping', 'pickup'].includes(deliveryType)) {
    if (noPrescription === true) return 'var(--q-negative)';
  }
  return '#e0e0e0';
}

export function orderDateCreatedColorCode(date) {
  const newDate = dayjs(date).locale('de');
  if (newDate.isValid()) {
    const day = newDate.day();
    // 0 => sunday
    switch (day) {
      case 0:
        return '#7f6001';
      case 1:
        return '#7f6001';
      case 2:
        return '#33a854';
      case 3:
        return '#b7b7b7';
      case 4:
        return '#e06666';
      case 5:
        return '#4185f4';
      case 6:
        return '#7f6001';
      default:
        return null;
    }
  }
  return null;
}

export function orderPaymentTypeColorCode(paymentType) {
  switch (paymentType) {
    case 'prepayment':
      return '#ffff04';
    default:
      return null;
  }
}

export function orderStatusColorCode(status) {
  switch (status) {
    case 'draft':
      return '#efefef';
    case 'subsequent_delivery':
      return '#ff00ff';
    case 'split_delivery':
      return '#ff00ff';
    case 'sent':
      return '#ffffff';
    case 'ready_to_ship':
      return '#ffffff';
    case 'no_date_of_delivery':
      return '#c8daf9';
    case 'cancellation':
      return '#C10015';
    default:
      return null;
  }
}

export function orderStatus(status) {
  switch (status) {
    case 'draft':
      return 'Entwurf';
    case 'inbox':
      return 'Eingegangen';
    case 'support':
      return 'Callcenter';
    case 'support_prio':
      return 'Callcenter-Prio';
    case 'laboratory':
      return 'Labor';
    case 'laboratory_prio':
      return 'Labor-Prio';
    case 'subsequent_delivery':
      return 'Nachlieferung';
    case 'split_delivery':
      return 'Teilbelieferung';
    case 'processing':
      return 'Rezept-Bearbeitung';
    case 'ready_to_ship':
      return 'Versandbereit';
    case 'sent':
      return 'Versendet / Ware übergeben';
    case 'no_date_of_delivery':
      return 'Freigegeben - ohne Liefertermin';
    case 'approval':
      return 'Freigegeben-Rücksprache';
    case 'released_consultation':
      return 'Freigegeben - Rücksprache';
    case 'cancellation':
      return 'Storno';
    case 'Gurkentisch':
      return 'approval';
    default:
      return null;
  }
}

export function filterSimpleObjectArray(array, key, val) {
  if (Array.isArray(array) && !!(array.length > 0)) {
    if (array.length > 0) {
      return array.filter((item) => item[key] == val);
    }
  }
  return false;
}

export function orderKeyMapper(key, val) {
  if (key == 'delivery_period') {
    return orderDeliveryPeriod(val);
  } else if (key === 'status') {
    return orderStatus(val);
  } else if (key == 'delivery_type') {
    return deliveryType(val);
  } else if (key == 'payment_type') {
    return paymentType(val);
  } else if (key == 'payment_status') {
    return paymentStatus(val);
  } else if (
    [
      'date_updated',
      'date_created',
      'preferred_date_of_delivery',
      'date_of_invoice',
      'date_of_payment',
      'payment_term'
    ].includes(key)
  ) {
    return date(val, 'dd DD.MM.YYYY');
  }
  return '';
}

export function orderKeys(key) {
  switch (key) {
    case 'responsible_employee':
      return 'Bearbeiter';
    case 'customer':
      return 'Kunde';
    case 'status':
      return 'Status';
    case 'handover_delivery_date':
      return 'Interne Liefertermin Übergabe';
    case 'preferred_date_of_delivery':
      return 'Bevorzugtes Lieferdatum';
    case 'delivery_period':
      return 'Lieferzeitraum';
    case 'delivery_type':
      return 'Lieferart';
    case 'date_of_invoice':
      return 'Rechnungsdatum';
    case 'date_of_payment':
      return 'Zahlungseingang';
    case 'ext_invoice_number':
      return 'Belegnummer';
    case 'payment_type':
      return 'Zahlungsart';
    case 'payment_status':
      return 'Zahlungsstatus';
    case 'payment_amount':
      return 'Rechnungssumme';
    case 'payment_term':
      return 'Auflösungsdatum';
    case 'location':
      return 'Ort';
    default:
      return null;
  }
}

export function truncate(string, limit) {
  if (string.length <= limit) {
    return string;
  }
  return `${string.slice(0, limit)}...`;
}

export function dateTomorrow(format) {
  const newDate = dayjs().add(1, 'day').locale('de').format(format);
  return newDate != 'Invalid Date' ? newDate : '';
}

export function dateSubtract(date, format, manipulation) {
  const newDate = dayjs(date).subtract(manipulation.value, manipulation.unit).locale('de').format(format);
  return newDate != 'Invalid Date' ? newDate : '';
}

export function dateAdd(date, format, manipulation) {
  const newDate = dayjs(date).add(manipulation.value, manipulation.unit).locale('de').format(format);
  return newDate != 'Invalid Date' ? newDate : '';
}

/**
 * The function returns the current date and time in the specified format, with the option to return an
 * empty string if the date is invalid.
 * @param format - The format parameter is a string that specifies the format of the date and time that
 * will be returned by the function. It uses the syntax of the dayjs library, which allows for a wide
 * range of formatting options. For example, "YYYY-MM-DD" would return the date in the format of year
 * @returns the current date and time in the specified format, using the dayjs library and the 'de'
 * locale. If the resulting date is invalid, an empty string is returned.
 */
export function dateNow(format) {
  return dayjs().locale('de').format(format);
}

export function dateEndOfWeek(format = 0, startDay = 1) {
  return dayjs().endOf('week').locale('de').format(format);
}

export function dateStartOfWeek(format, startDay = 1) {
  return dayjs().startOf('week').locale('de').format(format);
}

export function getLastDay(day = 0, format = 'YYYY-MM-DD') {
  return dayjs().day(day).locale('de').format(format);
}

export function dateTimeStartOfDay(date) {
  return `${date}T00:00:00.000Z`;
}

export function dateTimeEndOfDay(date) {
  return `${date}T23:59:59.999Z`;
}

/**
 * This function formats a given date string according to a specified format using the dayjs library
 * and returns the formatted date or an empty string if the input is invalid.
 * @param date - The date parameter is a string or a Date object representing the date to be formatted.
 * It can be in any format recognized by the dayjs library.
 * @param format - The format parameter is a string that specifies the format in which the date should
 * be displayed. It can include various placeholders for different parts of the date, such as "YYYY"
 * for the year, "MM" for the month, "DD" for the day, "HH" for the hour,
 * @returns a formatted date string in the specified format, using the dayjs library and the 'de'
 * locale. If the input date is invalid, an empty string is returned.
 */
export function date(date, format) {
  const newDate = dayjs(date).locale('de').format(format);
  return newDate != 'Invalid Date' ? newDate : '';
}

/**
 * The function converts a day of the week string into an integer representing the day (0 for Monday,
 * 1 for Tuesday, etc.).
 * @param day - A string representing a day of the week, such as "Mo", "Tu", "We", etc.
 * @returns an integer representing the day of the week based on the input string. If the input string
 * matches one of the cases in the switch statement, the corresponding integer value is returned. If
 * the input string does not match any of the cases, the function returns null.
 */
export function dayToInt(day) {
  switch (day) {
    case 'Mo':
      return 0;
    case 'Mo.':
      return 0;
    case 'Montag':
      return 0;
    case 'Tu':
      return 1;
    case 'Di':
      return 1;
    case 'Di.':
      return 1;
    case 'Dienstag':
      return 1;
    case 'We':
      return 2;
    case 'Mi':
      return 2;
    case 'Mi.':
      return 2;
    case 'Mittwoch':
      return 2;
    case 'Th':
      return 3;
    case 'Do':
      return 3;
    case 'Do.':
      return 3;
    case 'Donnerstag':
      return 3;
    case 'Fr':
      return 4;
    case 'Fr.':
      return 4;
    case 'Freitag':
      return 4;
    case 'Sa':
      return 5;
    case 'Sa.':
      return 5;
    case 'Samstag':
      return 5;
    case 'Su':
      return 6;
    case 'So':
      return 6;
    case 'So.':
      return 6;
    case 'Sonntag':
      return 6;
    default:
      return null;
  }
}

/**
 * This function checks if a given date falls on a specific day of the week.
 * @param date - The date parameter is a date object or a string representing a date in a format that
 * can be parsed by the dayjs library. It represents the date for which we want to check if it falls on
 * a specific day of the week.
 * @param day - The `day` parameter is a number representing the day of the week, where 0 is Sunday, 1
 * is Monday, and so on.
 * @returns The function `isDay` returns a boolean value indicating whether the given `date` falls on
 * the specified `day` of the week. It returns `true` if the `date` falls on the specified `day`, and
 * `false` otherwise. If either the `date` or `day` parameter is `null`, the function returns `false`.
 */
export function isDay(date, day) {
  if (date == null) {
    return false;
  }
  if (day == null) {
    return false;
  }
  const isDay = dayjs(date).locale('de').weekday() === day;
  return isDay;
}

/**
 * The function "daysToIntArray" converts an array of days (strings) to an array of integers
 * representing the days.
 * @param days - The parameter "days" is an array of strings representing days of the week (e.g.
 * ["Monday", "Tuesday", "Wednesday"]).
 * @returns The function `daysToIntArray` is returning an array of integers, where each integer
 * represents the day of the week (0 for Sunday, 1 for Monday, etc.) corresponding to the input array
 * `days`.
 */
export function daysToIntArray(days) {
  const intDays = [];
  days.forEach((day) => {
    intDays.push(dayToInt(day));
  });
  return intDays;
}

/**
 * This function checks if a given date falls on any of the specified days.
 * @param date - The `date` parameter is a date object representing a specific date.
 * @param days - The `days` parameter is a string representing a list of days in the format "1,3,5"
 * where each number represents a day of the week (1 = Monday, 2 = Tuesday, etc.). The function
 * `daysToIntArray` is used to convert this string into an array
 * @returns a boolean value (either true or false) depending on whether the input date falls on any of
 * the days specified in the input days parameter.
 */
export function isDateInDays(date, days) {
  if (date == null || days == null) {
    return false;
  }
  const intDays = daysToIntArray(days);
  for (let i = 0; i <= intDays.length - 1; i++) {
    if (isDay(date, intDays[i])) {
      return true;
    }
  }
  return false;
}

export function strUpperLower(val) {
  if (val.length === 0) {
    return ['', '']; // Return an array with two empty strings if the input is empty
  }

  const firstCharCap = val.charAt(0).toUpperCase();
  const firstCharLow = val.charAt(0).toLowerCase();

  return {
    cap: firstCharCap + val.slice(1),
    low: firstCharLow + val.slice(1)
  };
}

function formatString(str) {
  if (str.length === 0) {
    return ['', '']; // Return an array with two empty strings if the input is empty
  }

  const firstChar = str.charAt(0).toUpperCase();
  const secondChar = str.charAt(1).toLowerCase();

  return [firstChar, secondChar + str.slice(2)];
}

export function getMappedItems(items, cb) {
  let out = [];
  const length = items.length - 1;
  for (let i = 0; i <= length; i++) {
    const item = cb(items[i]);
    out[out.length] = item;
  }
  return out;
}

export function notificationCaption(val) {
  switch (val) {
    case 'inbox':
      return 'Eingegangen';
    case 'processing':
      return 'In Bearbeitung';
    case 'split_delivery':
      return 'Teilbelieferung';
    case 'subsequent_delivery':
      return 'Nachlieferung';
    case 'paid':
      return 'Bezahlt';
    case 'no_date_of_delivery':
      return 'Freigegeben ohne Liefertermin';
    case 'ready_to_ship_pickup':
      return 'Abholbereit';
    case 'cancellation':
      return 'Storno';
    case 'deliveryperiodconfirmation':
      return 'Lieferterminbestätigung';
    case 'draft':
      return 'Entwurf';
    case 'ready_to_ship':
      return 'Versandbereit';
    case 'laboratory':
      return 'Labor';
    case 'approval':
      return 'Freigegeben - Rücksprache';
    case 'support':
      return 'Callcenter';
    case 'support_prio':
      return 'Callcenter-Prio';
    case 'laboratory_prio':
      return 'Labor-Prio';
    case 'sent':
      return 'Versendet';
    default:
      return 'n.a.';
  }
}

export function notificationDescription(val) {
  switch (val) {
    case 'inbox':
      return 'Informiert über den Eingang des Rezeptes.';
    case 'processing':
      return 'Informiert darüber, dass der Vorgang in Bearbeitung ist.';
    case 'split_delivery':
      return 'Informiert darüber, dass der Vorgang teilbeliefert wird.';
    case 'subsequent_delivery':
      return 'Informiert darüber, dass der Vorgang nachbeliefert wird.';
    case 'paid':
      return 'Informiert darüber, dass der Vorgang bezahlt worden ist.';
    case 'no_date_of_delivery':
      return 'Informiert darüber, dass um Rückmeldung gebeten wird.';
    case 'ready_to_ship_pickup':
      return 'Informiert darüber, dass die Ware abholbereit ist.';
    case 'cancellation':
      return 'Informiert darüber, dass der Vorgang storniert wurde.';
    case 'deliveryperiodconfirmation':
      return 'Kunde hat den Liefertermin für den nächsten Werktag bestätigt';
    case 'draft':
      return 'Der Kunde wurde informiert, dass seine Reservierung erfasst wurde.';
    case 'ready_to_ship':
      return 'Der Kunde wurde informiert, dass sein Paket für den Versand vorbereitet wurde.';
    case 'laboratory':
      return 'Informiert darüber, dass der Vorgang in Bearbeitung ist.';
    case 'approval':
      return 'Informiert darüber, dass um Rückmeldung gebeten wird.';
    case 'sent':
      return 'Informiert darüber, dass die Ware versendet wurde.';
    case 'support':
      return 'Informiert darüber, dass der Vorgang in Bearbeitung ist.';
    case 'support_prio':
      return 'Informiert darüber, dass der Vorgang in Bearbeitung ist.';
    case 'laboratory_prio':
      return 'Informiert darüber, dass der Vorgang in Bearbeitung ist.';
    default:
      return 'n.a.';
  }
}

export function countryToCountryCode(countryName) {
  const euCountryCodes = new Map([
    ['austria', 'AT'],
    ['belgium', 'BE'],
    ['bulgaria', 'BG'],
    ['croatia', 'HR'],
    ['cyprus', 'CY'],
    ['czechia', 'CZ'],
    ['czech republic', 'CZ'],
    ['denmark', 'DK'],
    ['estonia', 'EE'],
    ['finland', 'FI'],
    ['france', 'FR'],
    ['germany', 'DE'],
    ['deutschland', 'DE'],
    ['Deutschland', 'DE'],
    ['greece', 'GR'],
    ['hungary', 'HU'],
    ['ireland', 'IE'],
    ['italy', 'IT'],
    ['latvia', 'LV'],
    ['lithuania', 'LT'],
    ['luxembourg', 'LU'],
    ['malta', 'MT'],
    ['netherlands', 'NL'],
    ['poland', 'PL'],
    ['portugal', 'PT'],
    ['romania', 'RO'],
    ['slovakia', 'SK'],
    ['slovenia', 'SI'],
    ['spain', 'ES'],
    ['sweden', 'SE']
  ]);

  euCountryCodes.get(countryName.toLowerCase()) || countryName;
}
